// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `of next person`
};

const de_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `vor der nächsten Person`
};

const es_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `de la siguiente persona`
};

const fr_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `sur la personne suivante`
};

const fi_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `seuraavasta henkilöstä`
};

const hi_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `अगले व्यक्ति से`
};

const ja_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `次の人より`
};

const nl_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `op de volgende persoon`
};

const pt_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `da próxima pessoa`
};

const ro_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `următoarea persoană`
};

const th_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `คนต่อไป`
};

const ur_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `اگلے شخص سے`
};

const zh_hant1_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `下一位`
};

const da_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `næste person`
};

const it_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `rispetto alla persona successiva`
};

const vn_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `người tiếp theo`
};

const ko_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `다음 사람보다`
};

const tr_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `bir sonraki kişiden`
};

const lv_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `nākamā persona`
};

const ar_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `عن الشخص التالي`
};

const bs_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `sljedeće osobe`
};

const sl_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `naslednji osebo`
};

const id_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `dari orang berikutnya`
};

const sv_widget_leaderboard_of_next_person = /** @type {(inputs: {}) => string} */ () => {
	return `av nästa person`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_leaderboard_of_next_person = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_leaderboard_of_next_person(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_leaderboard_of_next_person", locale)
	if (locale === "en") return en_widget_leaderboard_of_next_person(inputs)
	if (locale === "de") return de_widget_leaderboard_of_next_person(inputs)
	if (locale === "es") return es_widget_leaderboard_of_next_person(inputs)
	if (locale === "fr") return fr_widget_leaderboard_of_next_person(inputs)
	if (locale === "fi") return fi_widget_leaderboard_of_next_person(inputs)
	if (locale === "hi") return hi_widget_leaderboard_of_next_person(inputs)
	if (locale === "ja") return ja_widget_leaderboard_of_next_person(inputs)
	if (locale === "nl") return nl_widget_leaderboard_of_next_person(inputs)
	if (locale === "pt") return pt_widget_leaderboard_of_next_person(inputs)
	if (locale === "ro") return ro_widget_leaderboard_of_next_person(inputs)
	if (locale === "th") return th_widget_leaderboard_of_next_person(inputs)
	if (locale === "ur") return ur_widget_leaderboard_of_next_person(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_leaderboard_of_next_person(inputs)
	if (locale === "da") return da_widget_leaderboard_of_next_person(inputs)
	if (locale === "it") return it_widget_leaderboard_of_next_person(inputs)
	if (locale === "vn") return vn_widget_leaderboard_of_next_person(inputs)
	if (locale === "ko") return ko_widget_leaderboard_of_next_person(inputs)
	if (locale === "tr") return tr_widget_leaderboard_of_next_person(inputs)
	if (locale === "lv") return lv_widget_leaderboard_of_next_person(inputs)
	if (locale === "ar") return ar_widget_leaderboard_of_next_person(inputs)
	if (locale === "bs") return bs_widget_leaderboard_of_next_person(inputs)
	if (locale === "sl") return sl_widget_leaderboard_of_next_person(inputs)
	if (locale === "id") return id_widget_leaderboard_of_next_person(inputs)
	if (locale === "sv") return sv_widget_leaderboard_of_next_person(inputs)
	return "widget_leaderboard_of_next_person"
};